import React, { useRef, useState } from 'react'
import RequestCallback from './Booking/RequestCallback';
import Booking from './Booking/Booking';
import "../assets/css/home.css"
// import img1 from "../assets/Images/header/header1.jpg"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const HeroSection = () => {

    const [slidIndex, setSlidIndex] = useState(0);

    const settings = {
        dots: false,
        fade: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        arrows: false,
        autoplaySpeed: 8000,
        beforeChange: (current, next) => setSlidIndex(next),
    };

    const sliderRef = useRef();

    const handleOnClick = (index) => {
        sliderRef.current.slickGoTo(index);
    };

    return (
        <>
            <div>
                {/* <Slider ref={sliderRef} {...settings}> */}
                    <div className=''>
                        <div className="carousel-slide hero-sec-bg hero_section"
                          
                        >a
                            {/* Bg imga  */}
                            <div className='hero_crist_bg'>

                            </div>
                            {/*  ${slidIndex === 0 && 'customFadeUp'} */}
                            <div className={`slider-content`}>
                                <div>
                                    <h2 className='heading'> Build Smarter. Deliver Faster. Lead the Future.
                                    </h2>
                                    {/* <p className="mt-4">
                                        This Christmas, let us help take your Insolvency Practice to the next level with a
                                     <span className='fw-bold' style={{color: "rgb(103, 248, 255)", fontSize:"24px"}}> £500 Discount </span> 
                                     on all IT services. Whether you need a new Website, a Comprehensive Document Management System, or a Custom Mobile Application to streamline your operations, our team offers the right solutions to support your success. Don’t miss out — this exclusive holiday offer ends soon.
                                    </p> */}
                                    <p className='mt-4'>
                                    
 In construction, everyday counts—and so does every decision. From site to screen, Zithas Technologies equips your business with intelligent digital tools that simplify workflows, enhance collaboration, and drive project success. Whether you're managing subcontractors, juggling schedules, or tracking budgets, we help you build with precision, speed, and confidence.

 
                                    </p>
                                </div>

                                <div className='mt-5 hero_actions'>
                                    <RequestCallback btn_text={"Request a Call Back"} />
                                    <Booking />
                                    {/* <img src={santa} style={{height: "200px", marginLeft:"100px"}}></img> */}
                                </div>
                            </div>
                        </div>
                    </div>
            </div>

        </>
    )
}

export default HeroSection